<script>
  export let title
</script>

<div class="card card-outline shadow-sm">
  <div class="card-header bg-white">
    <h5 class="text-secondary m-0">{title}</h5>
  </div>
  <div class="card-body">
    <slot />
  </div>
</div>
